<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <lego-modal-extend-v2
    ref="modal"
    :title="modes[mode].title"
    @beforeClose="handleClose"
    class="log-metric"
    :subTitle="getSubTitle"
  >
    <div class="log-info" v-if="mode !== 'logSearch'">
      <AddNewInfo
        v-if="this.mode === 'addMetric'"
        v-model:description="metricDescription"
        v-model:name="metricName"
        ref="addNewInfo"
      />
      <InfoDetail
        v-else
        v-model:description="metricDescription"
        :name="metricName"
        :selectedLog="params.selectedLog[0]"
        :mode="mode"
        :detailActive="detailActive"
      />
    </div>

    <div class="log-container">
      <div
        ref="sectionController"
        class="section-1"
        v-if="mode !== 'metricDetail' && mode !== 'metricEdit'"
      >
        <template v-if="modes[mode].monitoring">
          <monitoring-target-common
            ref="monitoringTarge"
            :productCodes="productTypeCodes"
            :defaultProductCode="selectedCode.productCode"
            :productTypeGroups="productTypeGroups"
            :selectedItems="listChips"
            :isDisabled="disableProductType"
            :showErrorMessageMonitoringTarget="isValidMessage.isRequiredMonitoringTarget"
            :mode="mode"
            :isDisabledBtn="!isPassAuthorization"
            @change-product-type-code="onChangeProductType"
            @confirm-dialog="confirmSelectedItems"
            @remove="removeTarget"
            @close-dialog="closeDialog"
          >
            <AddMonitorTargetPopup
              :params="modalParam"
              @close="handleCloseAddMonitorTargetPopup"
              @selected-items="chooseItems"
            ></AddMonitorTargetPopup>
          </monitoring-target-common>
        </template>
      </div>

      <div class="section-2">
        <div class="condition">
          <search-condition
            ref="searchConditionRef"
            :productType="productTypeCode"
            :logSqIds="selectedTargets"
            :mode="mode"
            :logFields="logFields"
            :searchOptions="searchOptions"
            :dataLoaded="dataloaded"
            @on-search="handleSearchCondition"
            @on-reset="handleResetSearchCondition"
            @on-save-metric="(value, description) => _saveMetric(value, description)"
            @on-add-condition="handleAddCondition"
          />
        </div>

        <div class="graph" ref="graph">
          <c-scroll>
            <div class="wrap" ref="wrapLog" :class="{ 'wrap--scroll': isScrollWrap }">
              <scpm-sub-title class="wrap-sub-title"
                >{{ $t('page.log.logGraph') }}
                <template #action>
                  <scpm-reload-date-picker
                    ref="reloadPicker"
                    refreshPlay
                    @refresh="refresh"
                    @save="refresh('resetPage')"
                  />
                </template>
              </scpm-sub-title>
              <div v-if="targetFilter.length == 0">
                <NullWidget
                  :minHeight="500"
                  :errorMessage="logSearchNoData"
                  class="null-data-main"
                />
              </div>
              <div v-else class="log-generation">
                <div class="chart-container">
                  <ChartLogSearch
                    :opt="chartOptions"
                    v-if="!loadingChart"
                    :dateOption="dateOption"
                  />
                  <NullWidget v-else :minHeight="220" :errorMessage="errorMessage" />
                </div>
                <ScpmTabBox v-model="selectedLogTarget" :items="targetFilter" />
                <div class="log-message">
                  <!-- 모니터링 대상 -->

                  <lego-paging-table
                    class="cScroll-y detail-table"
                    :class="{ 'detail-table--line': heightMonitoringTarge > 100 }"
                    tableFixed
                    :items="items"
                    :headers="headers"
                    :pagination="page"
                    :selectActionControl="false"
                    @change="changeRowPerPage"
                    @page-move="changeCurrentPage"
                    @sort="onClickSortTable"
                    @clickRow="onClickRow"
                    ref="logTable"
                  >
                    <template #extra-action>
                      <!-- 다운로드 -->
                      <lego-drop-holder
                        class="dropdown"
                        :itemWidth="94"
                        :items="downloadType"
                        :disabled="items.length < 1"
                        @click="downloadLogMessage"
                        menuDirection="right"
                      >
                        <div :disabled="items.length < 1" class="btn-dropdown">
                          <lego-icon
                            iconType="line"
                            icon="download_small"
                            sm
                            :size="20"
                            v-lego-tooltip="{
                              value: $util.capitalize($t('label.download')),
                              moreAction: 'clickToHide'
                            }"
                          />
                        </div>
                      </lego-drop-holder>
                    </template>
                    <template #expand="expandProps">
                      <td :colspan="headers.length + 1">
                        <c-scroll
                          style="height: max-content; width: 100%; white-space: break-spaces"
                        >
                          <scpm-render-html
                            class="expand"
                            :template="expandProps.item.messageHtml"
                          />
                        </c-scroll>
                      </td>
                    </template>
                  </lego-paging-table>
                </div>
              </div>
            </div>
          </c-scroll>
        </div>
      </div>
    </div>

    <template #footer>
      <lego-button @click="handleClose()"
        >{{
          ['logSearch', 'metricDetail'].includes(this.mode)
            ? $t('button.close')
            : $t('button.cancel')
        }}
      </lego-button>

      <lego-button
        v-if="this.mode === 'addMetric'"
        :disabled="isDisabledConfirm"
        @click="addMetric(metricName)"
        main
        >{{ $t('button.save') }}
      </lego-button>

      <lego-button v-if="this.mode === 'metricDetail'" @click="changeEditMode" main
        >{{ $t('button.edit') }}
      </lego-button>

      <lego-button
        v-if="this.mode === 'metricEdit'"
        :disabled="!changedFieldData || isDisabledConfirm"
        @click="modifyMetric"
        main
        >{{ $t('button.save') }}
      </lego-button>
    </template>
  </lego-modal-extend-v2>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { saveAs } from 'file-saver';
import * as echarts from 'echarts/lib/echarts.js';

import tableMixins from '@/mixins/table.mixin.js';
import i18nMixin from '@/mixins/i18n.mixin.js';
import NullWidget from '@/containers/widget/components/NullWidget';
import ScpmReloadDatePicker from '@/components/scpm/components/scpmReloadDatePicker/scpmReloadDatePicker';
import AddMonitorTargetPopup from '@/containers/logs/logCollections/AddMonitorTargetPopup';
import LegoModalExtendV2 from '../../../components/lego/extend/legoModalExtendV2';
import MonitoringTargetCommon from '../../components/MonitoringTargetCommon.vue';
import SearchCondition from '../../components/searchCondition/SearchCondition.vue';
import ScpmTabBox from './components/ScpmTabBox.vue';
import ChartLogSearch from './components/ChartLogSearch.vue';
import AddNewInfo from './components/LogMetricInfo/AddNewInfo.vue';
import InfoDetail from './components/LogMetricInfo/InfoDetail.vue';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';
import { useChart } from '@/composables/useChart.js';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';

const { getProductTypeGroups } = useProductTypeGroups();
const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();
const { handleDataChart } = useChart();

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    disableProductType: {
      type: Boolean,
      default: () => false
    }
  },
  mixins: [tableMixins, i18nMixin, validateFieldsMixin],
  emits: ['loadMetrics', 'closeMetricEdit', 'close'],
  components: {
    NullWidget,
    ScpmReloadDatePicker,
    AddMonitorTargetPopup,
    LegoModalExtendV2,
    MonitoringTargetCommon,
    SearchCondition,
    ScpmTabBox,
    ChartLogSearch,
    InfoDetail,
    AddNewInfo
  },
  mounted() {
    this.$refs['modal'].open();
    this._pageInit();
    this.listenCheckScroll();
  },
  provide() {
    return {
      setCondition: (value) => (this.changedModelValid.checkCondition = value || false)
    };
  },
  watch: {
    selectedTargets: {
      handler() {
        this._getSearchFields();
        if (this.selectedTargets.length > 0) {
          this.isValidMessage.selectedTargets = false;
          this.isValidMessage.isRequiredMonitoringTarget = false;
        } else {
          this.clearData();
        }
        this.selectedItems = [...this.selectedTargets];
        this.getHeightMonitoringTarget();
      },
      deep: true,
      immediate: false
    },
    selectedItems: {
      handler(value) {
        this.listChips = value.map((item) => ({
          id: item['service.type'],
          label: `${item.productName}: <span style="color: #364fc7">${this.$util.escapeHTML(
            item['service.type']
          )}</span>`,
          isHTML: true,
          productResourceId: item.productResourceId
        }));
        if (value.length === 0) {
          this.page.currentPage = 1;
          this.page.totalItems = 0;
          this.hasTarget = false;
        } else {
          this.hasTarget = true;
        }
        this.getHeightMonitoringTarget();
      },
      deep: true
    },

    selectedLogTarget() {
      if (this.selectedLogTarget && this.dataloaded) {
        // 모니터링 대상 변경 시 로그 메시지 검색 결과 페이지 리셋
        this.page.currentPage = 1;
        this.getData();
      }
    },
    params: {
      handler(v) {
        this.selectedCode.productCode = v.productTypeCode;
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    modalParam() {
      return {
        selectedLog: this.selectedTargets,
        productTypeCode: this.productTypeCode,
        productTypeName: _.find(this.productTypeCodes, {
          productTypeCode: this.productTypeCode
        })?.productTypeName
      };
    },
    searchPlaceholder() {
      if (this.mode !== 'metricDetail') {
        return this.$t('page.log.searchValidation2');
      } else {
        return '';
      }
    },
    isShowPopup() {
      return this.popup.addTargetShow;
    },
    getSubTitle() {
      const checkPage = ['metricDetail', 'metricEdit'].includes(this.mode);
      if (checkPage) {
        return 'metricfilter.' + this.metricName;
      }
      return '';
    },
    isDisabledConfirm() {
      if (this.metricName.trim().length === 0) return true;
      if (this.$const.NOT_ALLOWED_REGEX.METRICNAME.test(this.metricName)) return true;
      if (this.$util.requireInputCommon(this.metricDescription)) return true;
      return this.targetFilter.length === 0 && this.selectedTargets.length === 0;
    }
  },
  data() {
    return {
      validateFieldKey: 'logSearch',
      productTypeCodes: [],
      productTypeGroups: [],
      productTypeCode: this.params.productTypeCode,
      prevProductTypeCode: this.params.productTypeCode,
      hasTarget: false,
      selectedCode: {
        productCode: '',
        subProductCode: ''
      },
      selectedItems: [],
      metricName:
        this.params.mode === 'metricDetail'
          ? this.params.selectedLog[0].metricName.replace('metricfilter.', '')
          : '',
      metricDescription:
        this.params.mode === 'metricDetail' ? this.params.selectedLog[0].description || '' : '',
      detailActive: '',

      selectedTargets: [],
      listChips: [],
      searchOptions:
        this.params.mode === 'metricDetail'
          ? JSON.parse(this.params.selectedLog[0].logQuery).map((q) => {
              q.compare = q.compare
                .replace('<=', '__LT__=')
                .replace('<', '__LT__')
                .replace('>=', '__GT__=')
                .replace('>', '__GT__');
              return q;
            })
          : [{ operator: 'AND', field: 'message', compare: 'like', value: '' }],
      logFields: [],
      dataloaded: false,
      dateOption: {},
      chartOptions: {
        grid: {
          left: 50,
          right: 25,
          top: 30,
          bottom: 40,
          containLabel: true
        },
        legend: {
          left: 0,
          bottom: 0,
          type: 'scroll'
        },
        xAxis: {
          type: 'time',
          axisTick: { show: false },
          axisLabel: {
            formatter: this._getChartDateFormat
          },
          splitNumber: 5
        },
        yAxis: {
          axisLabel: {
            width: 200
          },
          minInterval: 1
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          renderMode: 'html',
          className: 'toolbar-scrollbar',
          // extraCssText: 'max-height:200px;overflow:auto;',
          triggerOn: 'mousemove',
          enterable: false,
          transitionDuration: 0.8,
          appendToBody: true,
          position: (point, params, dom, rect, size) => {
            const pos = this.$util.getPositionTooltip(point, size);
            if (params.length > 7) return [pos[0], point[1] + 5];
            return pos;
          },
          axisPointer: {
            label: {
              formatter: ''
            }
          }
        },
        series: []
      },
      selectedLogTarget: null,
      loadingChart: false,
      optionFilter: [],
      targetFilter: [],

      headers: [
        {
          text: this.$util.capitalize(this.$t('label.num')), // 순번
          value: 'number',
          width: 80,
          sortable: false,
          bodyAlign: 'center'
        },
        {
          text: this.$util.capitalize(this.$t('label.occurrenceTime')), // 발생 시각
          value: '@timestamp',
          width: 170,
          sortable: true,
          isNotResize: true,
          customCell: {
            props: {
              value: {
                type: [String],
                default: ''
              }
            },
            computed: {
              time() {
                return formatDateTime(this.value, FULL_TIME_FORMAT);
              }
            },
            template: `<div class="ellipsis" v-lego-tooltip:ellipsis="time">{{ time }}</div>`
          }
        },
        {
          text: this.$util.capitalize(this.$t('searchLabel.msg')), // 메시지
          value: 'message',
          sortable: true,
          isNotResize: true,
          customCell: {
            props: {
              item: {
                type: Object
              },
              value: {
                type: [String, Object],
                default: ''
              },
              iIdx: {
                type: Number
              }
            },
            methods: {},
            computed: {
              setTemplate() {
                if (!this.value) {
                  return '';
                }

                return this.value;
              }
            },
            template: `
              <scpm-render-html class="ellipsis" :template="setTemplate"></scpm-render-html>`
          }
        }
      ],
      mode: this.params.mode,
      modes: {
        logSearch: {
          title: this.$util.capitalize(this.$t('label.log')) + ' ' + this.$t('button.search'),
          monitoring: true
        },
        addMetric: {
          title: this.$t('label.addMetric'),
          monitoring: true
        },
        metricDetail: {
          title: this.$t('label.metricDetail'),
          monitoring: false
        },
        metricEdit: {
          title: this.$t('label.modifyMetric'),
          monitoring: false
        }
      },

      isValidMessage: {
        selectedTargets: false,
        isRequiredMonitoringTarget: false
      },
      validator: {
        metricName: [
          (value) =>
            this.checkEmpty(value) || this.$t('message.input1', [this.$t('label.metricName')])
        ]
      },
      popup: {
        addTargetShow: false
      },

      downloadType: [
        { text: 'Text File', value: 'txt' },
        { text: 'Excel File', value: 'xls' }
      ],

      errorMessage: 'label.noData',
      logSearchNoData: 'message.logSearchNoData',

      reload: false,
      changedModelValid: {
        metricName: false,
        selectedItems: false,
        checkCondition: false,
        productTypeCode: false
      },
      heightMonitoringTarge: 0,
      sortedField: null,
      resizeObserver: null,
      isScrollWrap: false,
      isPassAuthorization: false
    };
  },
  methods: {
    onClickSortTable(item) {
      legoEventBus.$emit('click-outside-datePicker');
      this.sortedField = item;
      this.onClickSort(item);
    },
    // 초기화면 세팅
    async _pageInit() {
      // 상품유형 조회
      await this._getProductTypeCodes();

      this.isPassAuthorization = await this.checkProductSubTypeAuth(this.productTypeCode);

      if (this.mode !== 'addMetric' && this.params.selectedLog.length) {
        if (this.params.modeDetail) {
          this._getLogInfo(this.params.selectedLog[0]);
        } else {
          this.params.selectedLog.forEach((p) => {
            this._getLogInfo(p);
          });
        }
      }
      if (this.mode == 'addMetric') this.setFieldsBeforeModify();
    },

    // 상품유형 조회
    async _getProductTypeCodes() {
      const data = await this.$http.product.getProductSubTypes('Y');
      this.productTypeCodes = data;
      this.productTypeGroups = await getProductTypeGroups(data);
    },

    chooseItems(value) {
      this.changedModelValid.selectedItems = true;
      this.selectedItems = [...value];
    },

    confirmSelectedItems() {
      if (!_.isEqual(this.selectedTargets, this.selectedItems)) {
        this.selectedTargets = [...this.selectedItems];
      }
    },
    closeDialog() {
      // this.selectedTargets = this.$util.deepCopy(this.beforeSelectedTargets);
      this.selectedItems = [...this.selectedTargets];
    },

    removeTarget(item) {
      if (!item) {
        this.selectedTargets = [];
        this.selectedItems = [];
      } else {
        const idxItemRemove = this.selectedTargets.findIndex(
          (e) => e['service.type'] === item.id && e.productResourceId === item.productResourceId
        );
        idxItemRemove > -1 && this.selectedTargets.splice(idxItemRemove, 1);
        this.selectedItems = [...this.selectedTargets];
      }
    },

    async checkProductSubTypeAuth(productTypeCode) {
      const authData = await this.$store.dispatch('authStore/checkProductSubTypeAuthorization', {
        productTypeCode
      });
      return authData.type === this.$const.AuthorizationResult.ALLOW;
    },

    reloadScpmPicker() {
      this.$refs.reloadPicker.reloadComponent();
      this.$nextTick(() => {
        this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate('30m', () => {
          this.dateOption = this.$refs.reloadPicker.getCurrentDate();
        });
      });
    },

    // 상품유형 변경
    async onChangeProductType(value) {
      if (this.prevProductTypeCode === value) {
        return;
      }
      this.productTypeCode = value;
      this.selectedCode.productCode = value;

      const isPass = await this.checkProductSubTypeAuth(value);

      if (!isPass) {
        this.productTypeCode = this.prevProductTypeCode;
        this.selectedCode.productCode = this.prevProductTypeCode;
        return;
      }

      this.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.$t('title.notice'),
        message: `<div>` + this.$t('page.log.productEdit') + `</div>`,
        action: () => {
          this.productTypeCode = value;
          this.selectedCode.productCode = value;
          this.prevProductTypeCode = value;
          this.selectedTargets = [];
          this.changedModelValid.productTypeCode = true;
          this.isPassAuthorization = true;
          this._reset();
          this.reloadScpmPicker();
        },
        cancel: () => {
          this.productTypeCode = this.prevProductTypeCode;
          this.selectedCode.productCode = this.prevProductTypeCode;
        }
      });
    },

    // 검색 조건 - 검색 필드 조회
    _getSearchFields(isSearch = true) {
      if (this.selectedTargets.length > 0) {
        const params = [];

        this.selectedTargets.forEach((e) => {
          params.push({
            logName: e['service.type'],
            monKey: e.monKey
          });
        });

        this.$http.log
          .getLogFields(params, this.productTypeCode, true)
          .then((res) => {
            this.logFields = res.contents.map((l) => ({
              ...l,
              text: l.logFieldName,
              value: l.logFieldName
            }));
          })
          .then(() => {
            if (isSearch) this.onSearch();
          });
      }
    },

    clearData() {
      this.targetFilter = [];
      this.logFields = [];
      this._reset();
    },

    // 검색 조건 - 초기화 버튼
    handleResetSearchCondition() {
      this._reset(true);
      this.onSearch();
    },

    handleAddCondition(listCondition) {
      this.searchOptions = this.$util.deepCopy(listCondition);
    },

    handleSearchCondition() {
      this.onSearch(true);
    },

    async onSearch(executeHistory = false) {
      if (this.selectedTargets.length === 0) return;
      this.$refs.reloadPicker.resetReloadTime();
      this.dateOption = this.$refs.reloadPicker.getCurrentDate();

      this.optionFilter = this.$util.deepCopy(this.searchOptions);

      this.targetFilter = this.$util.deepCopy(this.selectedTargets);
      if (
        !this.selectedLogTarget ||
        this.targetFilter.findIndex(
          (item) =>
            item['service.type'] === this.selectedLogTarget['service.type'] &&
            item.productResourceId === this.selectedLogTarget.productResourceId
        ) < 0
      )
        this.selectedLogTarget = this.targetFilter[0];

      this.page.currentPage = 1;
      this._getLogDataUsage();
      this.getData({}, executeHistory);
      //this.setFieldsBeforeModify();
    },

    // 지표명 validation
    onInput(value) {
      this.$nextTick(() => {
        this.metricName = value.replace(/[^A-Za-z._-]/g, '');
        if (this.metricName && this.mode === 'addMetric') this.changedModelValid.metricName = true;
      });
    },

    // 초기화
    _reset(isResetSearchCondition = false) {
      if (this.mode !== 'metricEdit') {
        this._getSearchFields(false);
      }

      const searchOptionsDefault = [
        { operator: 'AND', field: 'message', compare: 'like', value: '' }
      ];
      if (!_.isEqual(searchOptionsDefault, this.searchOptions)) {
        this.changedModelValid.checkCondition = true;
      }
      this.searchOptions = [...searchOptionsDefault];

      // validation 초기화
      this.isValidMessage = {
        selectedTargets: false,
        isRequiredMonitoringTarget: false
      };

      if (!isResetSearchCondition) {
        this.dataloaded = false;
        this.page.currentPage = 1;
        this.page.totalItems = 0;
        this.items = [];

        if (this.mode !== 'metricEdit') {
          this.targetFilter = [];
          this.selectedLogTarget = null;
        }
      }
    },

    // 자동 refresh
    refresh(resetPage) {
      if (!this.dataloaded) return;
      if (resetPage) {
        this.page.currentPage = 1;
      }
      this.dateOption = this.$refs.reloadPicker.getCurrentDate();
      this._getLogDataUsage();
      this.getData();
    },

    formatLogData(logData, metricUnit) {
      return logData.map(({ ts, value }) => {
        const { value: chartValue } = this.$util.formatNumber(value, 2, metricUnit); //단위변환
        return [ts, chartValue];
      });
    },

    // 로그 그래프 조회
    async _getLogDataUsage() {
      this.dataloaded = false;
      let params = {
        logQuery: JSON.stringify(this.optionFilter),
        interval: this.dateOption.chartTimeUnit,
        queryStartDt: this.dateOption.queryStartDt,
        queryEndDt: this.dateOption.queryEndDt
      };

      let chartDatas = [];
      let series = [];
      this.loadingChart = true;
      await Promise.all(
        this.targetFilter.map(async (l) => {
          params.monKey = l.monKey;
          params.logName = l['service.type'];
          return await this.$http.log
            .getLogDataUsage(params, this.productTypeCode, !this.isShowPopup, true)
            .then((res) => {
              return {
                productName: l.productName,
                logName: res.logName,
                logCounts: res.logCounts
              };
            });
        })
      )
        .then(async (res) => {
          chartDatas = res || [];
          this.errorMessage = 'label.noData';
          let metricUnit = '';
          if (chartDatas.length > 0) {
            let allValues = [];
            chartDatas.forEach((item) => {
              allValues.push(Math.max(...item.logCounts.map((m) => Number(m.value))));
            });
            let maxValue = Math.max(...allValues);
            metricUnit = this.$util.formatNumber(maxValue, 2).unit; //max값으로 단위 결정

            chartDatas.forEach(({ logCounts, productName, logName }) => {
              const { chartTimeUnit, queryStartDt, queryEndDt } = this.dateOption;
              // Function format data before show chart
              const logCountsChart = handleDataChart(
                logCounts,
                chartTimeUnit,
                queryStartDt,
                queryEndDt
              );
              const logData = this.formatLogData(logCountsChart, metricUnit);

              // Function format data before download
              const downloadLogData = this.formatLogData(logCounts, metricUnit);

              const s = {
                name: `${productName}.${logName}`,
                type: 'line',
                data: logData,
                symbol: 'circle',
                cursor: 'default',
                silent: true,
                downloadData: downloadLogData
              };
              series.push(s);
            });
          }

          // x축
          this.chartOptions.xAxis.axisLabel.formatter = (value) => {
            return this._getChartDateFormat(value);
          };

          // y축
          this.chartOptions.yAxis.name = '(cnt)';
          this.chartOptions.yAxis.axisLabel.formatter = (value) => {
            return echarts.format.addCommas(value) + metricUnit;
          };

          // tooltip
          this.chartOptions.tooltip.valueFormatter = (value) => {
            return echarts.format.addCommas(value) + metricUnit;
          };
          this.chartOptions.tooltip.axisPointer.label.formatter = (item) => {
            return moment(item.value).format('YYYY-MM-DD HH:mm:ss');
          };
          this.chartOptions.series = series;

          setTimeout(() => {
            this.dataloaded = true;
          }, 200);
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied')
            this.errorMessage = `${
              'message.accessError' + error.params.find((item) => item.name == 'action').value
            }`;
        })
        .finally(() => {
          this.loadingChart = false;
        });
    },

    // 차트 date foramt
    _getChartDateFormat(value) {
      let type = this.dateOption.chartTimeUnit;
      return this.$util.getDateFormat(value, type);
    },

    escapeHtmlForPreventXss(message) {
      if (!message) {
        return message;
      }
      const regex = /(<font color='red'><b>|<\/b><\/font>)|./gi;
      let newMessage = message.replace(/[\n\t]+/g, ' ');
      return newMessage.replace(regex, (text) => {
        if (/<font color='red'><b>|<\/b><\/font>/gi.test(text)) {
          return text;
        }
        return this.$util.escapeHTML(text);
      });
    },

    // 로그 메시지 조회
    getData(searchParam, executeHistory = false) {
      const { param } = this.getSearchParamWithTrim(searchParam);
      const target = this.selectedTargets.find(
        (e) =>
          e['service.type'] === this.selectedLogTarget['service.type'] &&
          e.productResourceId === this.selectedLogTarget.productResourceId
      );
      param['logQuery'] = JSON.stringify(this.optionFilter);
      param['queryStartDt'] = this.dateOption.queryStartDt;
      param['queryEndDt'] = this.dateOption.queryEndDt;
      param['executeHistory'] = executeHistory;
      param['monKey'] = target.monKey;
      param['logName'] = target['service.type'];
      if (!this.hasTarget) {
        // Set data table for rerender update sort table
        this.setTableInfo({ contents: [], totalCount: 0 });
        return;
      }

      this.$http.log
        .getLogData(param, this.productTypeCode, !this.isShowPopup, true)
        .then((res) => {
          const htmlEl = document.createElement('div');
          res.contents = res.contents.map((d) => {
            const message = this.escapeHtmlForPreventXss(d.message);
            htmlEl.innerHTML = message;
            return {
              ...d,
              message,
              messageHtml: htmlEl.outerHTML
            };
          });
          this.setTableInfo(res);
        })
        .catch((error) => this.handleAccessDenied(error));
    },

    // 다운로드 로그 메시지
    async downloadLogMessage(item) {
      const sortParam = ['@timestamp:desc'];
      if (this.sortedField) {
        const { asc, value } = this.sortedField;
        sortParam[0] = `${value}:${asc ? 'asc' : 'desc'}`;
      }
      let downloadType = item.value.toUpperCase();
      const target = this.selectedTargets.find(
        (e) =>
          e['service.type'] === this.selectedLogTarget['service.type'] &&
          e.productResourceId === this.selectedLogTarget.productResourceId
      );
      let param = {
        logQuery: JSON.stringify(this.optionFilter),
        queryStartDt: this.dateOption.queryStartDt,
        queryEndDt: this.dateOption.queryEndDt,
        downloadType: downloadType,
        sort: sortParam,
        page: 0,
        userLanguage: window.localStorage.getItem('language').replace('_', '-'),
        userTimezone: window.sessionStorage.timeZoneInfo || moment.tz.guess(),
        monKey: target.monKey,
        logName: target['service.type']
      };

      await this.$http.log
        .downloadLogData(param, this.productTypeCode, downloadType, true)
        .then((res) => {
          let blob = new Blob([res]);
          const serviceType = this.selectedLogTarget['service.type'];
          let log = this.targetFilter.find(
            (item) =>
              item['service.type'] === serviceType &&
              item.productResourceId === this.selectedLogTarget.productResourceId
          );
          const currentTime = formatDateTime().replace(/[-: "]/g, '');
          const fileName = `${log.productName}_${serviceType}_${currentTime}.${item.value}`;
          saveAs(blob, fileName);
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied') this.$alert(error, () => {});
        });
    },

    // 지표 추가 - 저장 버튼
    addMetric(metricName) {
      if (!this.$util.validate([this.$refs.addNewInfo.validateMetricName()])) return;

      if (this.targetFilter.length === 0 && this.selectedTargets.length === 0) {
        this.isValidMessage.selectedTargets = true;
        this.isValidMessage.isRequiredMonitoringTarget = true;
        return;
      }

      if (!this.dataloaded) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.$t('label.notification'),
          message: this.$t('page.log.addMetric'),
          action: () => {}
        });
      } else {
        this._saveMetric(`metricfilter.${metricName}`, this.metricDescription);
      }
    },

    // 지표 수정 모드로 변환
    changeEditMode() {
      const item = this.selectedTargets.length
        ? this.selectedTargets[0]
        : this.params.selectedLog[0];
      const { productResourceId, productName } = item;
      let params = {
        productTypeCode: this.productTypeCode,
        productResourceIds: [productResourceId],
        actionName: 'MonitorSet',
        listDataCheckAuth: [
          {
            productResourceId: productResourceId,
            productName: productName
          }
        ]
      };

      this.$store
        .dispatch('authStore/checkProductResource', params)
        .then((data) => {
          if (data.type === this.$const.AuthorizationResult.ALLOW) {
            this.mode = 'metricEdit';
            this.setFieldsBeforeModify();
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },

    // 지표 수정 - 저장 버튼
    modifyMetric() {
      this._saveMetric('', this.metricDescription);
    },

    // 지표 저장
    _saveMetric(metricName, description = '') {
      const listCondition = this.$refs.searchConditionRef.listCondition;
      const isEditCondition = _.isEqual(listCondition, this.optionFilter);
      if (isEditCondition) {
        this.onSaveMetric(metricName, description.trim());
        return;
      }
      window.app.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.$t('title.notice'),
        message: this.$t('page.log.modifySearchCondition'),
        cancel: () => {
          if (this.mode !== 'addMetric' && metricName) {
            this.$refs.searchConditionRef.togglePopup('addMetricShow');
          }
        },
        action: () => {
          this.onSaveMetric(metricName, description.trim());
        }
      });
    },

    onSaveMetric(metricName, description) {
      if (metricName) {
        let params = {
          logQuery: JSON.stringify(this.optionFilter),
          logInfos: this.targetFilter.map((l) => {
            return {
              logName: l['service.type'],
              monKey: l.monKey
            };
          }),
          metricName,
          description
        };
        // 추가
        this.$http.log
          .addLogMetrics(params, this.productTypeCode)
          .then(() => {
            if (this.mode === 'addMetric') {
              this.$toast.open(this.$t('toast.metricManagement.addSuccess'));
              this.$emit('loadMetrics');
              this.close();
            } else {
              this.$toast.open(this.$t('toast.logCollection.logSearchAddMetricSuccess'));
              this.$refs.searchConditionRef.togglePopup('addMetricShow');
              this.reload = true;
            }
          })
          .catch(() => {
            this.$toast.open(this.$t('toast.logCollection.logSearchAddMetricFail'));
          });
      } else {
        let params = {
          logQuery: JSON.stringify(this.optionFilter),
          description
        };
        // 수정
        this.$http.log
          .updateLogMetrics(params, this.targetFilter[0].metricSq, this.productTypeCode)
          .then(() => {
            this.$toast.open(this.$t('toast.metricManagement.modifySuccess'));
            this.$emit('loadMetrics', 'edit');
            if (this.mode !== 'metricEdit') {
              this.close();
            }
          })
          .catch(() => {
            this.$toast.open(this.$t('toast.metricManagement.modifyFail'));
          });
      }
    },

    // 모니터링 대상 상태정보 조회
    _getProductState() {
      const payload = {
        loading: false,
        params: {
          productSq: this.params.selectedLog[0].productSq,
          productTypeCode: this.productTypeCode,
          listDataCheckAuth: [
            {
              productResourceId: this.params.selectedLog[0].productSq,
              productName: this.params.selectedLog[0].productName
            }
          ]
        }
      };

      this.$store.dispatch('authStore/checkProduct', payload).then((res) => {
        if (res.type !== this.$const.AuthorizationResult.ALLOW) return;
        const data = res.responseData;

        this.detailActive = this.$util.runningIcon(data.productState, data.productState);
      });
    },

    // 로그 상세 정보 조회
    async _getLogInfo(target) {
      let params = {
        monKey: target.monKey,
        sort: ['@timestamp:desc'],
        size: 0,
        page: 0
      };
      const logsData = this.$util.deepCopy(this.params.selectedLog);
      await this.$http.log.getLogs(params, target.productTypeCode).then((res) => {
        if (res.contents) {
          res.contents.map((item) => {
            let check = true;
            if (this.mode === 'metricDetail') {
              if (item['service.type'] !== this.params.selectedLog[0].logName) return;
            }
            if (this.params.modeDetail) {
              const checkLogsData = logsData.filter(
                (e) => e['service.type'] === item['service.type']
              );
              if (!checkLogsData.length) check = false;
            }
            check &&
              this.selectedTargets.push({
                ...item,
                productName: target.productName,
                logName: item['service.type'],
                monKey: target.monKey,
                productResourceId: target.productResourceId,
                productSq: target.productSq,
                metricSq: target.metricSq
              });
          });
        }
      });
    },

    // 로그 검색 팝업 닫기
    close() {
      if (this.mode === 'metricEdit') {
        this.$emit('closeMetricEdit');
        return;
      }
      this.$emit('close', this.reload);
    },

    handleCloseAddMonitorTargetPopup() {
      this.popup.addTargetShow = false;
    },
    handleClose() {
      if (['addMetric', 'metricEdit'].every((mode) => mode !== this.mode)) return this.close();
      this.showMessageWhenChange(this.close);
    },
    getHeightMonitoringTarget() {
      this.$nextTick(() => {
        const sectionController = this.$refs.sectionController;
        if (sectionController) {
          this.heightMonitoringTarge = sectionController.clientHeight;
        }
      });
    },
    onClickRow(item) {
      legoEventBus.$emit('click-outside-datePicker');
      try {
        this.$refs.logTable.$refs.table.onClickRowExpand(item, true);
      } catch (error) {
        return;
      }
    },
    listenCheckScroll() {
      const wrapLog = this.$refs.wrapLog;
      const graphRef = this.$refs.graph;
      this.resizeObserver = new ResizeObserver(() => {
        this.isScrollWrap = wrapLog.scrollHeight > graphRef.clientHeight;
      });
      if (this.resizeObserver) {
        this.resizeObserver.observe(wrapLog);
      }
    }
  },
  unmounted() {
    const toolbarScrollbar = document.querySelector('.toolbar-scrollbar');
    if (toolbarScrollbar) {
      toolbarScrollbar.remove();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
};
</script>
<style lang="scss" scoped>
:deep .lego-table__th {
  position: unset !important;
}

.log-container {
  height: 100%;
  max-height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;

  .section-1 {
    border-bottom: 1px solid #e3e4e8;

    .expand {
      padding: 0 20px;
      white-space: normal;
    }

    .cus-echart {
      height: 220px;
      width: calc(100% + 20px);
      padding: 0 20px 0 0;
    }

    .monitoringTitle {
      width: calc(100% - 2px);
      height: 32px;
      font-family: $lego__font-family;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      color: var(--dark);
      background-color: var(--color-primary-tint-01);
    }
  }

  .section-2 {
    display: flex;
    gap: 24px;
    flex: 1;
    height: 100%;
    overflow: auto;
    max-height: 100%;

    .condition {
      width: 328px;
      min-width: 328px;
      border-right: 1px solid #e3e4e8;
    }

    .graph {
      flex: 1;
      height: 100%;
      max-height: 100%;

      .chart-container {
        width: 100%;
        height: 230px;
        border-radius: 4px;
        border: 1px solid #e3e5e8;
        background: #fff;
        margin-top: 6px;
      }

      .wrap {
        &--scroll {
          padding-right: 20px;
        }

        .detail-section {
          margin-top: 32px;
        }

        .wrap-sub-title {
          align-items: center;

          :deep(.scpmSubTitle) {
            color: #2e3138;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 16px;
            font-family: $lego__font-family;
          }
        }

        .log-message {
          border: red;

          .mornitoring {
            width: 400px;
            margin-right: 24px;
            border-right: 1px solid #e3e5e8;

            .monitoring-title {
              color: #2e3138;
              font-family: $lego__font-family;
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              line-height: 16px;
            }
          }

          .detail-table {
            width: 100%;

            :deep(.lego-table__no-data) {
              min-height: 173px !important;
            }

            &--line {
              :deep(.lego-table__no-data) {
                min-height: 130px !important;
              }
            }
          }

          .radio-item-label {
            width: 235px;
            display: block;
            font-style: normal;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.null-data-main {
  :deep(.c-label) {
    color: #737a8c !important;
  }
}

.btn-dropdown {
  width: 24px;
  height: 24px;
  background: #ffffff;
  cursor: pointer;

  :deep(svg) {
    color: #555b68;

    .lego-drop-holder--disabled & {
      opacity: 0.5;
    }
  }
}

.log-metric {
  :deep(.modal__body) {
    height: 100%;
    display: flex;
    overflow: hidden;
    gap: 24px;
    padding: 24px 0;
  }

  :deep(.modal__title-bar__sub) {
    color: #2e3138;
  }
}

.log-info {
  width: 278px;
  border-right: 1px solid #e3e4e8;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.log-generation {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

:deep .lego-dropdown__item:hover {
  background-color: rgba(54, 79, 199, 0.12) !important;
}
</style>
